var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"mx-auto mt-5",attrs:{"sm":"5"}},[_c('login',{on:{"login":_vm.login}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }